(function () {
  let notifyMeModalContainer = null;
  let notifyMeModalForm = null;

  document.addEventListener("DOMContentLoaded", function () {
    initNotifyMeModal();
  });

  function initNotifyMeModal() {
    notifyMeModalContainer = document.querySelector(".notify-me-modal");

    if (!notifyMeModalContainer) {
      console.warn("NotifyMeModal container not found in DOM.");
      return;
    }

    notifyMeModalForm = document.querySelector(".notify-me-modal-form");

    if (!notifyMeModalForm) {
      console.warn("NotifyMeModal form not found.");
      return;
    }

    setupModalClose();
    setupFormSubmission();
    setupRealTimeTagUpdates();

    hideNotifyMeModal();
    checkForExistingToast();

    document.addEventListener("openNotifyMeModal", handleOpenModal);
  }

  function checkForExistingToast() {
    const urlParams = new URLSearchParams(window.location.search);
    const customerPosted = urlParams.get("customer_posted");
    const contactForm = window.location.hash === "#contact_form";

    if (customerPosted === "true" && contactForm) {
      const toast = document.getElementById("notifyMeToast");
      if (toast) {
        removeCustomerPostedFromURL();
        toast.style.display = "flex";
        setTimeout(() => toast.classList.add("show"), 100);
        setTimeout(() => {
          toast.classList.remove("show");
          setTimeout(() => {
            toast.style.display = "none";
          }, 400);
        }, 3100);
      } else {
        showSuccessToast();
      }
    }
  }

  function updateCombinedTags() {
    if (!notifyMeModalForm) return;
    const combinedTagsInput = notifyMeModalForm.querySelector(".combined-tags-input");
    if (!combinedTagsInput) return;

    const tags = [];
    const phoneInput = notifyMeModalForm.querySelector("[data-phone-input]");
    if (phoneInput && phoneInput.value.trim()) {
      const phoneValue = phoneInput.value.trim();
      tags.push(phoneValue.startsWith("phone_") ? phoneValue : `phone_${phoneValue}`);
    }

    const variantInput = notifyMeModalForm.querySelector("[data-variant-input]");
    if (variantInput && variantInput.value.trim()) tags.push(variantInput.value.trim());

    const sizeInput = notifyMeModalForm.querySelector("[data-size-input]");
    if (sizeInput && sizeInput.value.trim()) tags.push(sizeInput.value.trim());

    const actionInput = notifyMeModalForm.querySelector("[data-action-tag]");
    if (actionInput && actionInput.value.trim()) tags.push(actionInput.value.trim());

    const marketingCheckbox = notifyMeModalForm.querySelector("[data-marketing-opt-in]");
    tags.push(marketingCheckbox && marketingCheckbox.checked === false ? "marketing_UNSUBSCRIBED" : "marketing_SUBSCRIBED");

    combinedTagsInput.value = tags.join(",");
  }

  function addMarketingOptIn() {
    const marketingOptInInput = notifyMeModalForm?.querySelector(".marketing-opt-in-input");
    const marketingCheckbox = notifyMeModalForm?.querySelector("[data-marketing-opt-in]");
    if (marketingOptInInput && marketingCheckbox) {
      marketingOptInInput.value = marketingCheckbox.checked ? "true" : "false";
    }
  }

  function setupRealTimeTagUpdates() {
    const phoneInput = notifyMeModalForm?.querySelector("[data-phone-input]");
    if (phoneInput) {
      phoneInput.addEventListener("input", updateCombinedTags);
      setupPhoneInputValidation(phoneInput);
    }

    const marketingCheckbox = notifyMeModalForm?.querySelector("[data-marketing-opt-in]");
    if (marketingCheckbox) {
      marketingCheckbox.addEventListener("change", function () {
        updateCombinedTags();
        addMarketingOptIn();
      });
    }
  }

  function setupPhoneInputValidation(phoneInput) {
    phoneInput.addEventListener("keypress", function (event) {
      const allowedChars = /[0-9\s\-\(\)\+]/;
      if (!allowedChars.test(event.key) && !["Backspace", "Delete", "Tab", "Enter"].includes(event.key)) {
        event.preventDefault();
      }
    });

    phoneInput.addEventListener("input", function (event) {
      const cleanedValue = event.target.value.replace(/[^0-9\s\-\(\)\+]/g, "");
      if (event.target.value !== cleanedValue) event.target.value = cleanedValue;
    });
  }

  function handleOpenModal(event) {
    const { variantId, size } = event.detail;
    showNotifyMeModal(variantId, size);
  }

  function showNotifyMeModal(variantId = null, size = null) {
    if (!notifyMeModalContainer) return;

    currentVariantId = variantId;

    if (variantId) {
      const variantInput = notifyMeModalContainer.querySelector("[data-variant-input]");
      if (variantInput) variantInput.value = `notify_variant_${variantId}`;
    }

    const sizeInput = notifyMeModalContainer.querySelector("[data-size-input]");
    if (sizeInput) sizeInput.value = size ? `size_${size}` : "";

    updateCombinedTags();
    addMarketingOptIn();

    notifyMeModalContainer.style.display = "flex";
    document.body.style.overflow = "hidden";

    requestAnimationFrame(() => notifyMeModalContainer.classList.add("show"));
  }

  function hideNotifyMeModal() {
    if (!notifyMeModalContainer) return;

    document.body.style.overflow = "";
    notifyMeModalContainer.classList.remove("show");

    setTimeout(() => {
      notifyMeModalContainer.style.display = "none";
    }, 300);
  }

  function setupModalClose() {
    const closeButton = notifyMeModalContainer?.querySelector('.notify-me-modal-close');
    if (closeButton) {
      closeButton.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        hideNotifyMeModal();
      });
    }

    notifyMeModalContainer?.addEventListener("click", function (event) {
      if (event.target === notifyMeModalContainer) hideNotifyMeModal();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && notifyMeModalContainer?.classList.contains("show")) {
        hideNotifyMeModal();
      }
    });
  }

  function setupFormSubmission() {
    notifyMeModalForm?.addEventListener("submit", function () {
      updateCombinedTags();
      addMarketingOptIn();
    });
  }

  function showSuccessToast() {
    removeCustomerPostedFromURL();
    let toast = document.getElementById("notifyMeToast");

    if (!toast) {
      toast = document.createElement("div");
      toast.id = "notifyMeToast";
      toast.className = "notify-me-modal-toast";
      toast.style.display = "none";
      toast.innerHTML = 'You\'ll be notified! <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 12 2 2 4-4"></path><circle cx="12" cy="12" r="10"></circle></svg>';
      document.body.appendChild(toast);
    }

    toast.style.display = "flex";
    setTimeout(() => toast.classList.add("show"), 100);
    setTimeout(() => {
      toast.classList.remove("show");
      setTimeout(() => toast.style.display = "none", 400);
    }, 3100);
  }

  function removeCustomerPostedFromURL() {
    const url = new URL(window.location);
    const params = url.searchParams;

    if (params.has("customer_posted")) {
      params.delete("customer_posted");
      url.hash = "";
      window.history.replaceState({}, document.title, url.pathname + (params.toString() ? "?" + params.toString() : ""));
    }

    const anchorTags = document.querySelectorAll('a[href*="customer_posted"]');
    anchorTags.forEach(anchor => {
      try {
        const anchorUrl = new URL(anchor.href);
        const anchorParams = anchorUrl.searchParams;
        if (anchorParams.has("customer_posted")) {
          anchorParams.delete("customer_posted");
          anchor.href = anchorUrl.pathname + (anchorParams.toString() ? "?" + anchorParams.toString() : "");
        }
      } catch { /* skip invalid URLs */ }
    });

    const elementsWithDataUrls = document.querySelectorAll('[data-filter-url*="customer_posted"], [data-url*="customer_posted"], [data-href*="customer_posted"], [data-page*="customer_posted"]');
    elementsWithDataUrls.forEach(element => {
      ["data-filter-url", "data-url", "data-href", "data-page"].forEach(attrName => {
        const attrValue = element.getAttribute(attrName);
        if (attrValue && attrValue.includes("customer_posted")) {
          try {
            const dataUrl = new URL(attrValue, window.location.origin);
            const dataParams = dataUrl.searchParams;
            if (dataParams.has("customer_posted")) dataParams.delete("customer_posted");
            const newDataUrl = dataUrl.pathname + (dataParams.toString() ? "?" + dataParams.toString() : "");
            element.setAttribute(attrName, newDataUrl);
          } catch {
            const cleanedUrl = attrValue.replace(/[?&]customer_posted=true/g, "").replace(/customer_posted=true[?&]/g, "").replace(/customer_posted=true/g, "");
            element.setAttribute(attrName, cleanedUrl);
          }
        }
      });
    });
  }

  // Expose only necessary functions globally
  window.openNotifyMeModal = function (variantId = null, size = null) {
    const event = new CustomEvent("openNotifyMeModal", { detail: { variantId, size } });
    document.dispatchEvent(event);
  };

  window.closeNotifyMeModal = hideNotifyMeModal;
  window.hideNotifyMeModal = hideNotifyMeModal;
  window.showNotifyMeModal = showNotifyMeModal;
  window.initNotifyMeModal = initNotifyMeModal;

})();
